import { useRef, useState } from "react";

export default function useWizardEngine(steps) {
  const [index, setIndex] = useState(0);
  const dataRef = useRef({});
  const validateRef = useRef(null);

  return {
    step: steps[index],
    index,
    isFirst: index === 0,
    isLast: index === steps.length - 1,
    dataRef,
    validateRef,

    next() {
      if (validateRef.current && !validateRef.current()) return;
      setIndex(i => Math.min(i + 1, steps.length - 1));
    },

    prev() {
      validateRef.current = null;
      setIndex(i => Math.max(i - 1, 0));
    }
  };
}
